import { Button, Flex, Text } from "@chakra-ui/react"
import { FiMapPin } from "react-icons/fi";
import { buscaCoordenadasAtuais } from "../../../utils/geolocalizacao";
import { openInNewTab } from "../../../utils/openInNewTab";

interface IProps {
  latitude: string;
  longitude: string;
  margin?: boolean;
}

const RotaButton = ({ latitude, longitude, margin = true }: IProps) => {
  const goToMaps = async () => {
    const geolocalizacao = await buscaCoordenadasAtuais();

    if (!geolocalizacao?.latitude || !geolocalizacao?.longitude) {
      return;
    }

    const from = `${geolocalizacao.latitude},${geolocalizacao.longitude}`;
    const to = `${latitude},${longitude}`;
    const url = `https://www.google.com.br/maps/dir/${encodeURIComponent(
      from
    )}/${encodeURIComponent(to)}`;
    openInNewTab(url);
  }

  return (
    <Button mx={margin ? 1 : 0} size="xs" colorScheme="blackAlpha" onClick={goToMaps}>
      <Flex justify="center">
        <FiMapPin /> <Text ml={1}>COMO CHEGAR?</Text>
      </Flex>
    </Button>
  )
}

export default RotaButton;